const POST_MESSAGES = {
    CLOSE_FORM: 'supportPortalClose',
    OPEN_FEEDBACK: 'supportPortalOpenFeedback'
}

export { POST_MESSAGES }
